import React, { Fragment } from 'react';
import Navbar2 from '../../components/Navbar2';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import FacebookOnboarding from '../../components/FacebookOnboarding/FacebookOnboarding';

const FacebookOnboardingPage = () => {
  return (
    <Fragment>
      <Navbar2 />
      <FacebookOnboarding />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default FacebookOnboardingPage;
